import Reveal from "./Reveal";

const logos = [
  { src: "/brand/backers/elevate-nxt.png", alt: "ELEVATE Nxt 2026", cap: "max-h-9" },
  { src: "/brand/backers/startup-karnataka.png", alt: "Startup Karnataka", cap: "max-h-10" },
  { src: "/brand/backers/innovate-karnataka.png", alt: "Innovate Karnataka", cap: "max-h-8" },
  { src: "/brand/backers/nasscom-deeptech.png", alt: "nasscom deeptech", cap: "max-h-12" },
  { src: "/brand/backers/msme.png", alt: "Ministry of MSME, Government of India", cap: "max-h-14" },
];

export default function Backers({ title = "Backed by India's deep-tech ecosystem" }) {
  return (
    <section className="border-y border-white/5 py-14" data-testid="backers">
      <div className="container-x">
        <Reveal>
          <p className="overline text-center">{title}</p>
        </Reveal>
        <Reveal delay={0.08}>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-4 md:gap-5">
            {logos.map((l) => (
              <div
                key={l.alt}
                title={l.alt}
                className="flex h-24 w-44 items-center justify-center rounded-xl border border-white/10 bg-paper px-6 py-4 transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-ember/40"
              >
                <img
                  src={l.src}
                  alt={l.alt}
                  className={`${l.cap} w-auto max-w-full object-contain`}
                />
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
